import React from 'react'
import {urls} from 'helpers/url'
import {t} from "helpers/language"


export const skill = {
    key: "ADD_INVOICE",
    group: 'invoicing',
    label: t("Add an invoice"),
    desc: t("Create a new invoice against an existing quote"),
    steps: [
        {
            target: '.header-addButton',
            content: <div>To create an invoice <i>Tap The Add Button</i>. You can use this button at any time to add a new contact, activity, invoice or quote.</div>,
        },
        {
            target: '.addMenu-addInvoice',
            content: <div><i>Tap Add Invoice</i> to create a new invoice</div>,
            placement: 'left',
            awaitElement: {
                interval: 50,
            },
        },
        {
            // Inline tooltip in quote dialog
            dummy: true,
            addInvoiceDialog: true,
        },
        {
            target: '.invoiceHeader-markPostedButton',
            content: (
                <div>
                    To record that you have added this invoice to your accounts system, click <i>MARK AS POSTED</i>.
                </div>
            ),
        },
        {
            content: (
                <div>
                    If you are integrating with an accounts package, for example <i>Xero</i>, you can post this invoice
                    directly into your accounts system. See our accounts integrations to get started.
                </div>
            ),
            actions: [
                {
                    label: "See Accounts Integrations",
                    flat: true,
                    type: 'nav',
                    location: urls.integrations.accountsIntegrations,
                },
                {
                    label: "Learn More Skills",
                    flat: true,
                    type: 'skills',
                },
                {
                    label: 'Finish',
                    primary: true,
                    type: 'finish',
                },
            ],
        },
    ],
}

export default skill
